<template>
  <div>
    <div class="quick-add mid-align">
      <ul class="clearfix margin-15 font-12" v-if="isVisitor">
        <li><a class="quick-teacher" @click.prevent="showCurche"></a><span>添加老师</span></li>
        <li><a class="quick-kids" @click.prevent="showCurche"></a><span>添加学生 / 家长</span></li>
        <li><router-link class="quick-hostcenter" :to="{path:'/user/center/hostTeacherRegister'}"></router-link><span>新建园点</span></li>
        <li><a class="quick-dynamic" @click.prevent="showCurche"></a><span>发布动态</span></li>
        <li><a class="quick-food" @click.prevent="showCurche"></a><span>发布伙食</span></li>
        <li><a class="quick-rollcall" @click.prevent="showCurche"></a><span>发起点名</span></li>
      </ul>
      <ul class="clearfix margin-15 font-12" v-else>
        <li><router-link class="quick-teacher" :to="{path:'/invitation/teacher'}"></router-link><span>添加老师</span></li>
        <li><router-link class="quick-kids" :to="{path:'/invitation/parents'}"></router-link><span>添加学生 / 家长</span></li>

        <li v-if="cookie_login_data.jobId == 1"><router-link class="quick-hostcenter" :to="{path:'/user/center/hostcenterApply'}" ></router-link><span>新建园点</span></li>
        <li v-else><router-link class="quick-hostcenter" :to="{path:'/user/center/hostTeacherRegister'}"></router-link><span>新建园点</span></li>

        <li><router-link class="quick-dynamic" :to="{'path' : '/dynamic/publish/0'}"></router-link><span>发布动态</span></li>
        <li><router-link class="quick-food" :to="{'path' : '/dynamic/publish/1'}"></router-link><span>发布伙食</span></li>
        <li><router-link class="quick-rollcall" :to="{path:'/rollcall/list'}"></router-link><span>发起点名</span></li>
      </ul>
    </div>
    <div class="bottom-bar">
      <a class="block text-center padding-15 font-16" href="javascript:window.history.go(-1)">取消</a>
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'

export default {
  data () {
    return {
      jobName: '',
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      isVisitor: false
    }
  },
  mounted: function () {
    if (this.login_data.length <= 0) {
      this.isVisitor = true
    }
  },
  methods: {
    showCurche: function () {
      Toast('亲爱的老师，您还没有加入任何园点，请联系管理员为您开通')
    }
  }
}
</script>
<style scoped>
  .main-page{padding-bottom:60px;}
</style>


// WEBPACK FOOTER //
// quickAdd.vue?42d9a936